import { render, staticRenderFns } from "./biax.vue?vue&type=template&id=2782dd90"
import script from "./biax.vue?vue&type=script&lang=js"
export * from "./biax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports